import { Component, OnInit, ViewChild, Inject } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatDatepickerInputEvent,
  MatDialog,
  MAT_DIALOG_DATA,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import * as moment from "moment";
import { FormControl } from "@angular/forms";
import { SapRoles, roleTypeGroup } from "src/_constants/roleType";
import { Router } from "@angular/router";

export interface DialogData {
  dataInfo: any;
}
@Component({
  selector: "app-sap-metrics",
  templateUrl: "./sap-metrics.component.html",
  styleUrls: ["./sap-metrics.component.scss"],
})
export class SapMetricsComponent implements OnInit {
  DisplayedColumns: string[] = [
    "Operator",
    "Total No Of Active Users",
    "Total No Of Bets",
    "Total Bet Amount",
    "Total User Win Amount",
    "Total Pl",
    "Commission",
    "GGR",
    // "Current Balance",
    // "Total Deposit",
    // "Total Withdrawal",
  ];
  BetFairDisplayedColumns: string[] = [
    "Operator",
    "Total No Of Active Users",
    "Total No Of Bets",
    "Total Bet Amount",
    "Total User Win Amount",
    "Total Pl",
    "Commission",
    "Current Balance",
    "Total Deposit",
    "Total Withdrawal",
  ];
  selected: any = {
    startDate: new Date().setHours(0, 0, 0, 0),
    endDate:
      Number(new Date().setHours(23, 59, 59).toString().slice(0, 10)) * 1000,
  };
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  providers: any = JSON.parse(sessionStorage.getItem("category"));
  sapRoles = SapRoles;
  datalist = new MatTableDataSource<any>();
  selectedProvider = new FormControl([]);
  showAlert: any = false;
  title = "SAP Metrics"
  sports = [];
  operatorData = [];
  groupList = [];
  selectedSport = new FormControl([]);
  selectedGroup = new FormControl([]);
  origins = ["SPORTSBOOK","PREMIUM","EXPREMIUM"];
  origin = new FormControl([]);
  dropdownSettings: any = {};
  groupSettings: any = {};
  sportSettings: any = {};
  originSettings: any = {};
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  constructor(private appService: AppService, public dialog: MatDialog,private router: Router) {}

  ngOnInit() {
    if (roleTypeGroup.includes(this.userRole.role) || this.userRole.role == "MetricsAdmin") {
      this.title = "Group Metrics";
    }
    this.groupSettings = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.dropdownSettings = {
      singleSelection: true,
      idField: "ProviderId",
      textField: "ProviderName",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.sportSettings = {
      singleSelection: true,
      idField: "SportId",
      textField: "SportName",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.originSettings = {
      singleSelection: false,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    if (
      this.userRole.role === this.sapRoles.SAPAdmin ||
      this.userRole.role === this.sapRoles.SAPUser ||
      this.userRole.role === this.sapRoles.RiskAdmin
    ) {
      this.providers = ["SportsBook","Exchange"];
    }
    this.onSelectedProvider(this.providers[0]);
     // this.getOurProviders();
     this.getReportData()
     this.getOperatorData();
  }   
  @ViewChild(MatPaginator) paginator: MatPaginator;

  getOurProviders() {
    try {
      this.appService.getOurProviders().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.providers = res.providers;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
          }
        }
      });
    } catch (err) {}
  }
  onSelectedProvider = (pid) => {
    if (pid == "Exchange") {
      this.getSportsByProvider("BetFair");
    } else {
      this.getSportsByProvider("SportRadar");
    }
    this.origin.setValue([]);
    this.selectedProvider.setValue([pid]);
    // this.getReportData();
  };

  onChangeEventDate(event: any) {
    event.startDate = moment(new Date().setHours(0, 0, 0, 0));
    event.endDate = moment(new Date().setHours(0, 0, 0, 0));
  }

  getOperatorData() {
    try {
      this.appService.getOperatorId().subscribe((res) => {
        if (res.status === "RS_OK") {
          const uniqueGroups = {};
          this.operatorData = res.operators;
            res.operators.map((operator) => {
              if (operator.group !== "") {
                uniqueGroups[operator.group] = true;
              }
            });
            this.groupList =  Object.keys(uniqueGroups);
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }
  
  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.endDate) {
      let start = this.selected.startDate;
      let end = this.selected.endDate;
      let diff = end.diff(start, "days") + 1;

      if (diff > 35) {
        this.showAlert = true;
        this.selected.startDate = moment(new Date().setHours(0, 0, 0, 0));
        this.selected.endDate = moment(new Date().setHours(23, 59, 59));
        setTimeout(() => {
          this.showAlert = false;
        }, 5000);
      } else if (this.selected.startDate !== null) {
        // this.getReportData();
      }
    }
  };

  getSportsByProvider(providerId) {
    try {
      this.appService.getSportForBetList(providerId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.sports = res.sports;
          this.sports.unshift({ SportId: "All", SportName: "All Sports" });
          this.selectedSport.setValue([this.sports[0]]);
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  onChangeSports() {
    this.selectedSport.setValue([this.sports[0]]);
  }

  myFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    // Prevent Saturday and Sunday from being selected.
    return day !== 0 && day !== 6;
  };

  b64toBlob(b64Data, contentType, sliceSize?) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  getExportExcel() {
    const operators = this.selectedGroup.value.length != 0 ? this.operatorData.filter(operator => operator.group === this.selectedGroup.value[0]) : []
    let filters = {
      providerId: this.selectedProvider.value[0],
      operators : operators.map(operator => operator.operator_id),
      startTime: 
        this.selected.startDate !== null
          ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
          : 0,
      endTime:
        this.selected.endDate !== null
          ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
          : 0,
      origin: this.origin.value.length != 0 ? this.origin.value : [],
      sportId: this.selectedSport.value[0].SportId === 'All'? "": this.selectedSport.value[0].SportId,
      sportName: this.selectedSport.value[0].SportId === 'All'? "": this.selectedSport.value[0].SportName,
    };

    this.appService.getSapMetricsData(filters).subscribe((res) => {
      const contentType = "application/vnd.ms-excel";
      let blob1 = this.b64toBlob(res.file, contentType);
      let blobUrl1 = URL.createObjectURL(blob1);
      const link = document.createElement("a");
      link.href = blobUrl1;
      link.setAttribute("download", `operator_metrics.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  }

  getReportData = () => {
    const operators = this.selectedGroup.value.length != 0 ? this.operatorData.filter(operator => operator.group === this.selectedGroup.value[0]) : []
    try {
      let filters = {
        providerId:
          this.selectedProvider.value[0],
        operators : operators.map(operator => operator.operator_id),
        start_time:
          this.selected.startDate !== null
            ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
            : 0,
        end_time:
          this.selected.endDate !== null
            ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
            : 0,
        origin: this.origin.value.length != 0 ? this.origin.value : [],
        sportId: this.selectedSport.value[0].SportId === 'All'? "": this.selectedSport.value[0].SportId,
        sportName: this.selectedSport.value[0].SportId === 'All'? "": this.selectedSport.value[0].SportName,
      };
      this.appService.getSAPMetricsData(filters).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.datalist = new MatTableDataSource<any>(res.matrices);
          this.datalist.paginator = this.paginator;
        }
      });
    } catch (err) {}
  };

  getTotalValue(column: string) {
    return this.datalist.filteredData
      .map((t) => t[column])
      .reduce((acc, value) => acc + value, 0);
  }
}

@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./sap_metrics_modal.component.html",
  styleUrls: ["./sap-metrics.component.scss"],
})
export class SAPMetricsModal {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private appService: AppService
  ) {}

  getBetPlaceDate(date: number) {
    return moment.unix(date / 1000).format("DD MMM YYYY hh:mm A");
  }
}
